import { Moon, Sun } from 'lucide-react';

import { Button } from 'components/ui/button';
import { cn } from 'lib/utils';
import { useTheme } from 'providers/ThemeProvider';

interface ThemeToggleProps {
  /** Variant prop kept for backwards compatibility (always uses toggle behavior) */
  variant?: 'toggle' | 'dropdown';
  /** Additional classes */
  className?: string;
}

/**
 * Theme toggle component - Simple light/dark switch
 * Click to toggle between light and dark mode
 */
export const ThemeToggle = ({ className }: ThemeToggleProps) => {
  const { isDark, toggleMode } = useTheme();

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleMode}
      className={cn('h-9 w-9 relative', className)}
      aria-label="Alternar tema"
    >
      {/* Sun icon - visible in dark mode */}
      <Sun
        className={cn(
          'h-4 w-4 absolute transition-all duration-300',
          isDark ? 'rotate-0 scale-100 opacity-100' : 'rotate-90 scale-0 opacity-0'
        )}
        data-testid="sun-icon"
      />
      {/* Moon icon - visible in light mode */}
      <Moon
        className={cn(
          'h-4 w-4 absolute transition-all duration-300',
          isDark ? '-rotate-90 scale-0 opacity-0' : 'rotate-0 scale-100 opacity-100'
        )}
        data-testid="moon-icon"
      />
    </Button>
  );
};

export default ThemeToggle;
